export default {
  disconnect: {
    imageUrl: 'https://static.beeline.ru/upload/images/b2c/family-with-beeline/warning-triangle.svg',
    title: 'Отключиться из семьи номера {{PHONE}}?',
    description: 'После отключения оплата за услуги связи будет списываться с вашего баланса',
    buttonGroup: [
      {
        buttonText: 'Отключиться',
      },
      {
        buttonText: 'Остаться в семье',
      },
    ],
  },
  success: {
    imageUrl: 'https://static.beeline.ru/upload/images/b2c/family-with-beeline/error-popup.svg',
    title: 'Вы отключились из семьи номера {{PHONE}}',
    description: 'Теперь вы оплачиваете связь со своего баланса',
    informationText: 'На вашем тарифе недоступен мобильный интернет.',
    changeTariffText: 'Поменять тариф',
    changeTariffLink: '/customers/products/mobile/tariffs/',
    buttonText: 'Хорошо',
  },
  error: {
    imageUrl: 'https://static.beeline.ru/upload/images/b2c/family-with-beeline/warning-triangle.svg',
    title: 'Что-то пошло не так',
    description: 'Повторить попытку или попробуйте позже',
    buttonText: 'Понятно',
  },
};
